<div [matTooltip]="(progress | grecoDuration) + ' / ' + (duration | grecoDuration)">
  <mat-progress-bar mode="determinate" [value]="value$ | async"></mat-progress-bar>
</div>
